

const SVGShapesCategories = {
	'building': 'Buildings',
	'body': 'Body',
	'comic': 'Comics',
	'electric': 'Electronics',
	'emoji': 'Emoji',
	'energy': 'Energy',
	'food': 'Food',
	'games': 'Games',
	'halloween': 'Halloween',
	'maths': 'Maths',
	'nature': 'Nature',
	'science': 'Science',
	'sci-fi': 'Sci-Fi',
	'shape': 'Shapes',
	'sport': 'Sports',
	'tool': 'Tools',
	'face': 'Emoji',
	'star': 'Stars',
	'vehicle': 'Vehicles',
	'weather': 'Weather',
};
